import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ConsultingSection from './components/ConsultingSection';
import DifferentialsSection from './components/DifferentialsSection';
import HowItWorksSection from './components/HowItWorksSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="font-sans antialiased">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ConsultingSection />
        <DifferentialsSection />
        <HowItWorksSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
